import React, { useEffect, useMemo, useState } from "react";
// import { Card, CardContent } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, LineChart, Line, CartesianGrid, Legend } from "recharts";
import { Trophy, Gauge, Timer, Users, Percent, Clock, BarChart2, PieChart as PieIcon, LineChart as LineIcon } from "lucide-react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../AuthContext";

/**
 * Student Analytics Dashboard
 * - Drop into your app and pass the API response as the `data` prop.
 * - All charts are responsive. Uses Recharts + Tailwind + shadcn/ui.
 *
 * <StudentAnalyticsDashboard data={apiData} />
 */

const sampleData = {
    accuracy: 100,
    avgTime: 73,
    best: { accuracy: 100, marks: 10, subject: "gk", timeSpent: 0 },
    leastTime: { questionId: "6880d149147afc4f4273de2e", time: 14 },
    mostTime: { questionId: "6880d149147afc4f4273de2c", time: 178 },
    percentile: 0,
    questionWise: [
        { questionId: "6880d149147afc4f4273de2b", selected: "b", timeSpent: 33 },
        { questionId: "6880d149147afc4f4273de2e", selected: "c", timeSpent: 14 },
        { questionId: "6880d149147afc4f4273de2f", selected: "c", timeSpent: 34 },
        { questionId: "6880d149147afc4f4273de2c", selected: "d", timeSpent: 178 },
        { questionId: "6880d149147afc4f4273de2d", selected: "d", timeSpent: 106 }
    ],
    rank: 0,
    roll_no: "987654",
    student: "Sandeep Kumar",
    subjectData: [
        { subject: "hindi", accuracy: 100, marks: 10, timeSpent: 0 },
        { subject: "english", accuracy: 100, marks: 10, timeSpent: 0 },
        { subject: "reasoning & aptitude", accuracy: 100, marks: 20, timeSpent: 0 },
        { subject: "gk", accuracy: 100, marks: 10, timeSpent: 0 }
    ],
    totalScore: 100,
    worst: { accuracy: 100, marks: 10, subject: "gk", timeSpent: 0 }
};

const sample10 = [
    {
        "accuracy": 82,
        "avgTime": 64,
        "best": {
            "subject": "english",
            "accuracy": 95,
            "marks": 24,
            "timeSpent": 27
        },
        "leastTime": {
            "questionId": "4c3cf6525d9f442a8bb71cdd",
            "time": 18
        },
        "mostTime": {
            "questionId": "24b65fb7322941b9955dfe14",
            "time": 172
        },
        "percentile": 40,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "a",
                "timeSpent": 172
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "b",
                "timeSpent": 41
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "c",
                "timeSpent": 137
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "c",
                "timeSpent": 164
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "a",
                "timeSpent": 18
            }
        ],
        "rank": 17,
        "roll_no": "178729",
        "student": "Sandeep Kumar",
        "subjectData": [
            {
                "subject": "maths",
                "accuracy": 67,
                "marks": 17,
                "timeSpent": 98
            },
            {
                "subject": "gk",
                "accuracy": 74,
                "marks": 23,
                "timeSpent": 178
            },
            {
                "subject": "hindi",
                "accuracy": 64,
                "marks": 9,
                "timeSpent": 51
            },
            {
                "subject": "english",
                "accuracy": 95,
                "marks": 24,
                "timeSpent": 27
            }
        ],
        "totalScore": 100,
        "worst": {
            "subject": "hindi",
            "accuracy": 64,
            "marks": 9,
            "timeSpent": 51
        }
    },
    {
        "accuracy": 75,
        "avgTime": 60,
        "best": {
            "subject": "maths",
            "accuracy": 77,
            "marks": 24,
            "timeSpent": 99
        },
        "leastTime": {
            "questionId": "f95cb31cd3c5427791ff09af",
            "time": 98
        },
        "mostTime": {
            "questionId": "9072c12997264818908320e9",
            "time": 196
        },
        "percentile": 27,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "a",
                "timeSpent": 159
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "d",
                "timeSpent": 140
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "d",
                "timeSpent": 196
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "c",
                "timeSpent": 98
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "c",
                "timeSpent": 178
            }
        ],
        "rank": 17,
        "roll_no": "987075",
        "student": "Anjali Sharma",
        "subjectData": [
            {
                "subject": "science",
                "accuracy": 80,
                "marks": 10,
                "timeSpent": 128
            },
            {
                "subject": "maths",
                "accuracy": 77,
                "marks": 24,
                "timeSpent": 99
            },
            {
                "subject": "english",
                "accuracy": 61,
                "marks": 12,
                "timeSpent": 22
            },
            {
                "subject": "hindi",
                "accuracy": 79,
                "marks": 13,
                "timeSpent": 46
            }
        ],
        "totalScore": 81,
        "worst": {
            "subject": "science",
            "accuracy": 80,
            "marks": 10,
            "timeSpent": 128
        }
    },
    {
        "accuracy": 99,
        "avgTime": 65,
        "best": {
            "subject": "gk",
            "accuracy": 75,
            "marks": 23,
            "timeSpent": 200
        },
        "leastTime": {
            "questionId": "b0b580a21b6f40fa976f463d",
            "time": 80
        },
        "mostTime": {
            "questionId": "d29dfa0d15f14eee9bf0df5e",
            "time": 161
        },
        "percentile": 71,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "d",
                "timeSpent": 104
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "c",
                "timeSpent": 80
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "c",
                "timeSpent": 87
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "b",
                "timeSpent": 151
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "c",
                "timeSpent": 161
            }
        ],
        "rank": 42,
        "roll_no": "205928",
        "student": "Ravi Singh",
        "subjectData": [
            {
                "subject": "maths",
                "accuracy": 97,
                "marks": 22,
                "timeSpent": 112
            },
            {
                "subject": "gk",
                "accuracy": 75,
                "marks": 23,
                "timeSpent": 200
            },
            {
                "subject": "reasoning & aptitude",
                "accuracy": 99,
                "marks": 18,
                "timeSpent": 190
            },
            {
                "subject": "english",
                "accuracy": 97,
                "marks": 12,
                "timeSpent": 69
            }
        ],
        "totalScore": 85,
        "worst": {
            "subject": "english",
            "accuracy": 97,
            "marks": 12,
            "timeSpent": 69
        }
    },
    {
        "accuracy": 77,
        "avgTime": 76,
        "best": {
            "subject": "maths",
            "accuracy": 75,
            "marks": 22,
            "timeSpent": 23
        },
        "leastTime": {
            "questionId": "69416c92ffd749cbb94a0efe",
            "time": 130
        },
        "mostTime": {
            "questionId": "e0990e3ad9e34f358a148510",
            "time": 175
        },
        "percentile": 84,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "c",
                "timeSpent": 175
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "a",
                "timeSpent": 168
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "c",
                "timeSpent": 142
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "a",
                "timeSpent": 130
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "b",
                "timeSpent": 155
            }
        ],
        "rank": 36,
        "roll_no": "131470",
        "student": "Neha Verma",
        "subjectData": [
            {
                "subject": "science",
                "accuracy": 71,
                "marks": 15,
                "timeSpent": 163
            },
            {
                "subject": "english",
                "accuracy": 96,
                "marks": 17,
                "timeSpent": 107
            },
            {
                "subject": "hindi",
                "accuracy": 77,
                "marks": 20,
                "timeSpent": 120
            },
            {
                "subject": "maths",
                "accuracy": 75,
                "marks": 22,
                "timeSpent": 23
            }
        ],
        "totalScore": 74,
        "worst": {
            "subject": "science",
            "accuracy": 71,
            "marks": 15,
            "timeSpent": 163
        }
    },
    {
        "accuracy": 95,
        "avgTime": 35,
        "best": {
            "subject": "maths",
            "accuracy": 84,
            "marks": 18,
            "timeSpent": 56
        },
        "leastTime": {
            "questionId": "a1be5beadac64b1db9b9e15f",
            "time": 11
        },
        "mostTime": {
            "questionId": "ec86f3a78f25403a9d252cb2",
            "time": 186
        },
        "percentile": 98,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "d",
                "timeSpent": 186
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "a",
                "timeSpent": 11
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "a",
                "timeSpent": 155
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "a",
                "timeSpent": 158
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "c",
                "timeSpent": 94
            }
        ],
        "rank": 27,
        "roll_no": "067418",
        "student": "Amit Kumar",
        "subjectData": [
            {
                "subject": "english",
                "accuracy": 93,
                "marks": 5,
                "timeSpent": 168
            },
            {
                "subject": "gk",
                "accuracy": 68,
                "marks": 11,
                "timeSpent": 87
            },
            {
                "subject": "science",
                "accuracy": 69,
                "marks": 8,
                "timeSpent": 177
            },
            {
                "subject": "maths",
                "accuracy": 84,
                "marks": 18,
                "timeSpent": 56
            }
        ],
        "totalScore": 55,
        "worst": {
            "subject": "english",
            "accuracy": 93,
            "marks": 5,
            "timeSpent": 168
        }
    },
    {
        "accuracy": 72,
        "avgTime": 48,
        "best": {
            "subject": "science",
            "accuracy": 90,
            "marks": 23,
            "timeSpent": 82
        },
        "leastTime": {
            "questionId": "760581ae1fa04e5890d813f5",
            "time": 63
        },
        "mostTime": {
            "questionId": "e8a48feffd7346d49e6b61a0",
            "time": 198
        },
        "percentile": 72,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "c",
                "timeSpent": 129
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "a",
                "timeSpent": 122
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "c",
                "timeSpent": 63
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "d",
                "timeSpent": 198
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "a",
                "timeSpent": 165
            }
        ],
        "rank": 11,
        "roll_no": "095974",
        "student": "Priya Patel",
        "subjectData": [
            {
                "subject": "science",
                "accuracy": 90,
                "marks": 23,
                "timeSpent": 82
            },
            {
                "subject": "reasoning & aptitude",
                "accuracy": 69,
                "marks": 5,
                "timeSpent": 63
            },
            {
                "subject": "hindi",
                "accuracy": 92,
                "marks": 21,
                "timeSpent": 12
            },
            {
                "subject": "maths",
                "accuracy": 72,
                "marks": 19,
                "timeSpent": 152
            }
        ],
        "totalScore": 98,
        "worst": {
            "subject": "reasoning & aptitude",
            "accuracy": 69,
            "marks": 5,
            "timeSpent": 63
        }
    },
    {
        "accuracy": 77,
        "avgTime": 66,
        "best": {
            "subject": "hindi",
            "accuracy": 70,
            "marks": 21,
            "timeSpent": 29
        },
        "leastTime": {
            "questionId": "131625bb9b2941acbc1fd772",
            "time": 54
        },
        "mostTime": {
            "questionId": "aa1bfa65f8624b008fc0331b",
            "time": 142
        },
        "percentile": 56,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "b",
                "timeSpent": 82
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "c",
                "timeSpent": 61
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "d",
                "timeSpent": 142
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "d",
                "timeSpent": 54
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "c",
                "timeSpent": 64
            }
        ],
        "rank": 9,
        "roll_no": "061217",
        "student": "Vikas Yadav",
        "subjectData": [
            {
                "subject": "hindi",
                "accuracy": 70,
                "marks": 21,
                "timeSpent": 29
            },
            {
                "subject": "reasoning & aptitude",
                "accuracy": 100,
                "marks": 17,
                "timeSpent": 32
            },
            {
                "subject": "gk",
                "accuracy": 61,
                "marks": 8,
                "timeSpent": 30
            },
            {
                "subject": "science",
                "accuracy": 100,
                "marks": 17,
                "timeSpent": 170
            }
        ],
        "totalScore": 70,
        "worst": {
            "subject": "gk",
            "accuracy": 61,
            "marks": 8,
            "timeSpent": 30
        }
    },
    {
        "accuracy": 88,
        "avgTime": 67,
        "best": {
            "subject": "reasoning & aptitude",
            "accuracy": 84,
            "marks": 21,
            "timeSpent": 122
        },
        "leastTime": {
            "questionId": "d4a339281fc642ef9a3ac4e9",
            "time": 34
        },
        "mostTime": {
            "questionId": "c7e39848725043afabceee8b",
            "time": 175
        },
        "percentile": 24,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "c",
                "timeSpent": 159
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "b",
                "timeSpent": 175
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "c",
                "timeSpent": 77
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "b",
                "timeSpent": 34
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "c",
                "timeSpent": 82
            }
        ],
        "rank": 34,
        "roll_no": "455725",
        "student": "Sneha Gupta",
        "subjectData": [
            {
                "subject": "hindi",
                "accuracy": 66,
                "marks": 17,
                "timeSpent": 131
            },
            {
                "subject": "maths",
                "accuracy": 70,
                "marks": 7,
                "timeSpent": 62
            },
            {
                "subject": "reasoning & aptitude",
                "accuracy": 84,
                "marks": 21,
                "timeSpent": 122
            },
            {
                "subject": "gk",
                "accuracy": 100,
                "marks": 8,
                "timeSpent": 142
            }
        ],
        "totalScore": 77,
        "worst": {
            "subject": "maths",
            "accuracy": 70,
            "marks": 7,
            "timeSpent": 62
        }
    },
    {
        "accuracy": 72,
        "avgTime": 60,
        "best": {
            "subject": "hindi",
            "accuracy": 97,
            "marks": 21,
            "timeSpent": 133
        },
        "leastTime": {
            "questionId": "05ac9e68746e400b8f672e9e",
            "time": 33
        },
        "mostTime": {
            "questionId": "fd499f14f66d41028bd0b66f",
            "time": 196
        },
        "percentile": 67,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "d",
                "timeSpent": 84
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "a",
                "timeSpent": 33
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "b",
                "timeSpent": 196
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "d",
                "timeSpent": 140
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "a",
                "timeSpent": 70
            }
        ],
        "rank": 12,
        "roll_no": "462034",
        "student": "Rohit Mehta",
        "subjectData": [
            {
                "subject": "maths",
                "accuracy": 78,
                "marks": 10,
                "timeSpent": 7
            },
            {
                "subject": "reasoning & aptitude",
                "accuracy": 92,
                "marks": 10,
                "timeSpent": 192
            },
            {
                "subject": "science",
                "accuracy": 81,
                "marks": 11,
                "timeSpent": 28
            },
            {
                "subject": "hindi",
                "accuracy": 97,
                "marks": 21,
                "timeSpent": 133
            }
        ],
        "totalScore": 54,
        "worst": {
            "subject": "maths",
            "accuracy": 78,
            "marks": 10,
            "timeSpent": 7
        }
    },
    {
        "accuracy": 97,
        "avgTime": 113,
        "best": {
            "subject": "science",
            "accuracy": 61,
            "marks": 25,
            "timeSpent": 82
        },
        "leastTime": {
            "questionId": "6a412fe214644d47a4209788",
            "time": 55
        },
        "mostTime": {
            "questionId": "3dff936cc06e4f50b37224d3",
            "time": 179
        },
        "percentile": 70,
        "questionWise": [
            {
                "questionId": "6880d149147afc4f4273de2b",
                "selected": "d",
                "timeSpent": 159
            },
            {
                "questionId": "6880d149147afc4f4273de2e",
                "selected": "a",
                "timeSpent": 103
            },
            {
                "questionId": "6880d149147afc4f4273de2f",
                "selected": "d",
                "timeSpent": 79
            },
            {
                "questionId": "6880d149147afc4f4273de2c",
                "selected": "c",
                "timeSpent": 179
            },
            {
                "questionId": "6880d149147afc4f4273de2d",
                "selected": "d",
                "timeSpent": 55
            }
        ],
        "rank": 36,
        "roll_no": "602859",
        "student": "Kiran Das",
        "subjectData": [
            {
                "subject": "gk",
                "accuracy": 70,
                "marks": 13,
                "timeSpent": 83
            },
            {
                "subject": "reasoning & aptitude",
                "accuracy": 87,
                "marks": 15,
                "timeSpent": 27
            },
            {
                "subject": "maths",
                "accuracy": 87,
                "marks": 23,
                "timeSpent": 107
            },
            {
                "subject": "science",
                "accuracy": 61,
                "marks": 25,
                "timeSpent": 82
            }
        ],
        "totalScore": 94,
        "worst": {
            "subject": "gk",
            "accuracy": 70,
            "marks": 13,
            "timeSpent": 83
        }
    }
]

const numberFmt = (n) => (n ?? 0).toLocaleString();
const pctFmt = (n) => `${(n ?? 0).toFixed(1)}%`;

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#a4de6c", "#d0ed57", "#8dd1e1", "#83a6ed", "#8e8df0", "#f08de2", "#f0ad8e"]; // used only to differentiate pie slices

function Stat({ icon: Icon, label, value, sub }) {
    return (
        <div className="bg-white border-2 rounded-2xl shadow-sm">
            <div className="p-5">
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-xl bg-gray-100"><Icon className="w-5 h-5" /></div>
                    <div>
                        <div className="text-sm text-gray-500">{label}</div>
                        <div className="text-2xl font-semibold leading-tight">{value}</div>
                        {sub && <div className="text-xs text-gray-500 mt-1">{sub}</div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

function Section({ title, icon: Icon, children, right }) {
    return (
        <section className="mt-6">
            <div className="flex items-center justify-between mb-3">
                <h2 className="flex items-center gap-2 text-lg font-semibold">
                    {Icon && <Icon className="w-5 h-5" />} {title}
                </h2>
                {right}
            </div>
            <div className="grid gap-4 md:grid-cols-12">{children}</div>
        </section>
    );
}

export default function StudentAnalytics({ data = null }) {
    const { id } = useParams();
    const { apipath, logout, wspath } = useAuth();
    const token = localStorage.getItem('token');
    // const [data, setData] = useState({});
    // const [loading, setLoading] = useState(true);

    // const getAnalytics = async()=>{
    //     try{
    //         const response = await axios.post(apipath+'/student_analytics', {'id':'6880d261db54b21f74d27dc3'}, {
    //             headers: {
    //                 Authorization: 'Bearer ' + token
    //             }
    //         });
    //         console.log(response.data);
    //         if(response.data.status === 'true'){
    //             setData(response.data);
    //             setLoading(false);
    //         }
    //     } catch (e){
    //         console.log(e);
    //     }
    // }
    // useEffect(()=>{
    //     getAnalytics();
    // },[])
    const attempted = data.questionWise?.length ?? 0;
    const estimatedCorrect = Math.round(((data.accuracy ?? 0) / 100) * attempted);
    const estimatedWrong = Math.max(0, attempted - estimatedCorrect);

    const timePie = useMemo(() => (data.questionWise || []).map((q, i) => ({
        name: q.questionId.slice(-4),
        value: q.timeSpent ?? 0
    })), [data.questionWise]);

    const subjectAccuracyData = useMemo(() => (data.subjectData || []).map((s) => ({
        subject: s.subject,
        accuracy: s.accuracy ?? 0
    })), [data.subjectData]);

    const subjectTimeData = useMemo(() => (data.subjectData || []).map((s, idx) => ({
        subject: s.subject,
        timeSpent: s.timeSpent ?? 0,
        idx
    })), [data.subjectData]);

    const qTimeLine = useMemo(() => (data.questionWise || []).map((q, i) => ({
        question: `Q${i + 1}`,
        time: q.timeSpent ?? 0
    })), [data.questionWise]);
    if (!data) return null;
    return (
        <div className="col-span-2">
            {/* Header */}
            <div className="mb-4 flex flex-col md:flex-row md:items-end md:justify-between gap-2">
                <div>
                    <h1 className="text-2xl md:text-3xl font-bold">Student Analytics</h1>
                    <p className="text-gray-500">{data.student} • Roll No: {data.roll_no}</p>
                </div>
            </div>

            {/* KPI Row */}
            <div className="grid gap-4 md:grid-cols-5">
                <Stat icon={Trophy} label="Total Score" value={`${numberFmt(data.totalScore)}%`} />
                <Stat icon={Gauge} label="Accuracy" value={`${numberFmt(data.accuracy)}%`} />
                <Stat icon={Timer} label="Avg Time / Q" value={`${numberFmt(data.avgTime)}s`} />
                <Stat icon={Users} label="Rank" value={data.rank ? `#${numberFmt(data.rank)}` : "-"} sub="vs peers" />
                <Stat icon={Percent} label="Percentile" value={data.percentile ? `${numberFmt(data.percentile)}th` : "-"} />
            </div>

            {/* Charts Row 1: Correct vs Wrong + Speed per Question */}
            <Section title="Overall Performance" icon={BarChart2}>
                <div className="md:col-span-4">
                    <div className="border-2 rounded-2xl shadow-sm h-full bg-white">
                        <div className="p-5 h-full">
                            <div className="text-sm font-medium mb-3">Correct vs Wrong</div>
                            <ResponsiveContainer width="100%" height={260}>
                                <PieChart>
                                    <Tooltip formatter={(value) => `${value}`} />
                                    <Legend />
                                    <Pie dataKey="value" nameKey="name" data={[
                                        { name: "Correct", value: estimatedCorrect },
                                        { name: "Wrong", value: estimatedWrong }
                                    ]} outerRadius={90} label>
                                        {[
                                            { name: "Correct", value: estimatedCorrect },
                                            { name: "Wrong", value: estimatedWrong }
                                        ].map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.name === "Correct" ? 'green' : 'red'} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>

                <div className="md:col-span-8">
                    <div className="rounded-2xl border-2 shadow-sm h-full bg-white">
                        <div className="p-5 h-full">
                            <div className="flex items-center justify-between mb-3">
                                <div className="text-sm font-medium">Time Share per Question</div>
                            </div>
                            <ResponsiveContainer width="100%" height={260}>
                                <PieChart>
                                    <Tooltip formatter={(value) => `${value}s`} />
                                    <Legend />
                                    <Pie dataKey="value" nameKey="name" data={timePie} outerRadius={90} label>
                                        {timePie.map((entry, index) => (
                                            <Cell key={`slice-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </Section>

            {/* Charts Row 2: Subject Accuracy + Subject Time */}
            <Section title="Subject Wise" icon={PieIcon}>
                <div className="md:col-span-7">
                    <div className="rounded-2xl border-2 shadow-sm h-full bg-white">
                        <div className="p-5 h-full">
                            <div className="text-sm font-medium mb-3">Accuracy by Subject</div>
                            <ResponsiveContainer width="100%" height={280}>
                                <BarChart data={subjectAccuracyData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="subject" interval={0} angle={-10} textAnchor="end" height={60} />
                                    <YAxis domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
                                    <Tooltip formatter={(v) => `${v}%`} />
                                    <Bar dataKey="accuracy" fill="darkcyan" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>

                <div className="md:col-span-5">
                    <div className="rounded-2xl border-2 shadow-sm h-full bg-white">
                        <div className="p-5 h-full">
                            <div className="text-sm font-medium mb-3">Time Spent by Subject</div>
                            <ResponsiveContainer width="100%" height={280}>
                                <LineChart data={subjectTimeData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="subject" interval={0} angle={-10} textAnchor="end" height={60} />
                                    <YAxis tickFormatter={(v) => `${v}s`} />
                                    <Tooltip formatter={(v) => `${v}s`} />
                                    <Line type="monotone" dataKey="timeSpent" />
                                </LineChart>
                            </ResponsiveContainer>
                            <div className="text-xs text-gray-500 mt-2">* Time data is 0 in your sample; chart will populate when available.</div>
                        </div>
                    </div>
                </div>
            </Section>

            {/* Charts Row 3: Time per Question */}
            <Section title="Question Wise Time" icon={LineIcon}>
                <div className="md:col-span-12">
                    <div className="rounded-2xl border-2 shadow-sm h-full bg-white">
                        <div className="p-5 h-full">
                            <div className="text-sm font-medium mb-3">Time Spent per Question</div>
                            <ResponsiveContainer width="100%" height={300}>
                                <LineChart data={qTimeLine}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="question" />
                                    <YAxis tickFormatter={(v) => `${v}s`} />
                                    <Tooltip formatter={(v) => `${v}s`} />
                                    <Line type="monotone" dataKey="time" />
                                </LineChart>
                            </ResponsiveContainer>
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
                                <Stat icon={Clock} label="Average Time" value={`${numberFmt(data.avgTime)}s`} />
                                <Stat icon={Clock} label="Most Time (Q)" value={`${data.mostTime}`} sub={`${numberFmt(data.mostTime)}s`} />
                                <Stat icon={Clock} label="Least Time (Q)" value={`${data.leastTime}`} sub={`${numberFmt(data.leastTime)}s`} />
                                <Stat icon={Trophy} label="Best Subject" value={data.best?.subject || "-"} sub={`Acc ${numberFmt(data.best?.accuracy)}%`} />
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            {/* Heatmap Placeholder (optional future) */}
            <Section title="Subject Performance vs Top 10 (Heatmap)" icon={BarChart2} right={<span className="text-xs text-gray-500">Provide top10SubjectPerformance[] to render</span>}>
                <div className="md:col-span-12">
                    <div className="rounded-2xl border-2 shadow-sm bg-white">
                        <div className="p-5">
                            <Heatmap top10={data.top10} data={data} />
                        </div>
                    </div>
                </div>
            </Section>
            <Section title="Question Performance vs Top 10 (Heatmap)" icon={BarChart2} right={<span className="text-xs text-gray-500">Provide top10SubjectPerformance[] to render</span>}>
                <div className="md:col-span-12">
                    <div className="rounded-2xl border-2 shadow-sm bg-white">
                        <div className="p-5">
                            <QuestionHeatmap top10={data.top10} data={data} />
                        </div>
                    </div>
                </div>
            </Section>
        </div>
    );
}

/** Simple heatmap using a tailwind grid. Pass data like:
 * top10 = [
 *   { user: "A", subjects: [{ name: "english", score: 80 }, { name: "maths", score: 60 }] },
 *   { user: "B", subjects: [{ name: "english", score: 90 }, { name: "maths", score: 70 }] },
 * ]
 */
function Heatmap({ top10 = [], data = {} }) {
    if (!top10 || top10.length === 0) {
        return <div className="text-sm text-gray-500">No data provided yet.</div>;
    }

    const subjects = Array.from(new Set(top10.flatMap((r) => r.subjectData.map((s) => s.subject))));

    const colorFor = (v) => {
        // scale 0-100 -> red to green
        const pct = Math.max(0, Math.min(100, v)) / 100;
        const r = Math.round(255 * (1 - pct));
        const g = Math.round(200 * pct + 55);
        return `rgb(${r}, ${g}, 120)`;
    };

    return (
        <>
            <div className="overflow-auto">

                <div className="ml-4 flex flex-col items-center">
                    <div
                        className="w-full h-6 rounded"
                        style={{
                            background: "linear-gradient(to right, rgb(255,55,120), rgb(0,255,120))",
                        }}
                    ></div>
                    <div className="flex justify-between w-full text-xs mt-1">
                        <span>0</span>
                        <span>100</span>
                    </div>
                </div>
                <table className="min-w-full text-sm">
                    <thead>
                        <tr>
                            <th className="text-left p-2 sticky left-0 bg-white z-10">Student</th>
                            {subjects.map((s) => (
                                <th key={s} className="p-2 text-left">{s}</th>
                            ))}
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={data} className="border-t">
                            <td className="p-2 sticky left-0 bg-white z-10">{data.student}</td>
                            {subjects.map((s) => {
                                const cell = data.subjectData.find((x) => x.subject === s);
                                const val = cell?.accuracy ?? 0;
                                return (
                                    <td key={s} className="p-1">
                                        <div className="h-8 rounded flex justify-center items-center" style={{ background: colorFor(val) }} title={`${val}%`} >{val}</div>
                                    </td>
                                );
                            })}
                        </tr>

                        {top10.map((row, idx) => (
                            <tr key={idx} className="border-t">
                                <td className="p-2 sticky left-0 bg-white z-10">{row.student}</td>
                                {subjects.map((s) => {
                                    const cell = row.subjectData.find((x) => x.subject === s);
                                    const val = cell?.accuracy ?? 0;
                                    return (
                                        <td key={s} className="p-1">
                                            <div className="h-8 rounded flex justify-center items-center" style={{ background: colorFor(val) }} title={`${val}%`} >{val}</div>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </>
    );
}


function QuestionHeatmap({ top10 = [], data = {} }) {
    if (!top10 || top10.length === 0) {
        return <div className="text-sm text-gray-500">No data provided yet.</div>;
    }

    const questions = Array.from(new Set(top10.flatMap((r) => r.questionWise.map((s) => s.questionId))));

    const colorFor = (v) => {
        // clamp between 0–100
        const pct = Math.max(0, Math.min(100, v)) / 100;

        // reversed: low → green, high → red
        const r = Math.round(255 * pct);        // increases with value
        const g = Math.round(200 * (1 - pct) + 55); // decreases with value
        return `rgb(${r}, ${g}, 120)`;
    };

    return (
        <div className="overflow-auto">
            <div className="ml-4 flex flex-col items-center">
                <div
                    className="w-full h-6 rounded"
                    style={{
                        background: "linear-gradient(to left, rgb(255,55,120), rgb(0,255,120))",
                    }}
                ></div>
                <div className="flex justify-between w-full text-xs mt-1">
                    <span>0</span>
                    <span></span>
                </div>
            </div>
            <table className="min-w-full text-sm">
                <thead>
                    <tr>
                        <th className="text-left p-2 sticky left-0 bg-white z-10">Student</th>
                        {questions.map((s) => (
                            <th key={s} className="p-2 text-left">{s}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr key={data} className="border-t">
                        <td className="p-2 sticky left-0 bg-white z-10">{data.student}</td>
                        {questions.map((s) => {
                            const cell = data.questionWise.find((x) => x.questionId === s);
                            const val = cell?.timeSpent ?? 0;
                            return (
                                <td key={s} className="p-1">
                                    <div className="h-8 rounded flex justify-center items-center" style={{ background: colorFor(val) }} title={`${val}%`} >{val}</div>
                                </td>
                            );
                        })}
                    </tr>

                    {top10.map((row, idx) => (
                        <tr key={idx} className="border-t">
                            <td className="p-2 sticky left-0 bg-white z-10">{row.student}</td>
                            {questions.map((s) => {
                                const cell = row.questionWise.find((x) => x.questionId === s);
                                const val = cell?.timeSpent ?? 0;
                                return (
                                    <td key={s} className="p-1">
                                        <div className="h-8 rounded flex justify-center items-center" style={{ background: colorFor(val) }} title={`${val}%`} >{val}</div>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
